import { Drawer, Table, Tag } from "antd";
import { Link } from "react-router-dom";

export const getStatusTag = (status) => {
  switch (status) {
    case 1:
      return <Tag color="#999999">En proceso</Tag>; // Default color
    case 2:
      return <Tag color="#1677ff">En revisión</Tag>; // Processing color
    case 3:
      return <Tag color="#52c41a">Emitido</Tag>; // Success color
    case 4:
      return <Tag color="#52c41a">Pagado</Tag>; // Success color
    case 5:
      return <Tag color="#f5222d">Cancelado</Tag>; // Error color
    default:
      return <Tag>Desconocido</Tag>;
  }
};

export default function ListDrawer({ visible, onClose, data, title, columns }) {
  const dataWithRowNumber = data.map((item, index) => ({
    ...item,
    key: item.VerificacionID || index,
    rowNumber: index + 1,
  }));

  const updatedColumns = columns.map(col => {
    if (col.dataIndex === 'ControlInterno') {
      return {
        ...col,
        render: (text, record) => <Link to={`/verificaciones/${record.VerificacionID}`}>{text}</Link>
      };
    }
    return col;
  });

  return (
    <Drawer title={title} placement="right" onClose={onClose} visible={visible} width={800}>
      <Table 
        dataSource={dataWithRowNumber} 
        columns={updatedColumns} 
        pagination={{ pageSize: 100, position: ['topLeft', 'bottomRight'] }}
        size="small"
      />
    </Drawer>
  );
}
